import type { FormModule, FormModuleFn } from "./form-sdk";

// A compiled form module (form-sdk.ts) is one ES module whose default export is form(sdk), kept as
// JavaScript on the fileset that carries it. It is imported through a blob URL, as a stored page is
// (page-dsl/loader.ts). FEATURE-20261021-check-config-type-and-fileset-form.

/** Import a compiled form module's JavaScript; `name` is for the error. */
export async function importFormModule(js: string, name: string): Promise<FormModuleFn> {
  const url = URL.createObjectURL(new Blob([js], { type: "text/javascript" }));
  try {
    const mod = (await import(/* @vite-ignore */ url)) as Partial<FormModule>;
    if (typeof mod.default !== "function") {
      throw new Error(`form module ${name} has no default export function form(sdk)`);
    }
    return mod.default;
  } finally {
    URL.revokeObjectURL(url);
  }
}
